import React, { ReactNode } from 'react';

import { Box } from 'components/Box';
import { PrimaryButtonLink } from 'components/Button';
import Icon from 'components/Icon/Icon';

type Props = {
  href: string;
  children: ReactNode | null | undefined;
};

export function StickyHeaderLinksBlockExternalLink({ href, children }: Props) {
  return (
    <PrimaryButtonLink href={href} target="_blank">
      {children}
      <Box transform="translateY(1px)" display="inline-block" ml="6px">
        <Icon name="external-link" width={12} stroke="currentColor" />
      </Box>
    </PrimaryButtonLink>
  );
}
